export const loggerConnectOptions = {
    reconnection: true,
    reconnectionDelay: 5000,
    reconnectionAttempts: 10,
    perMessageDeflate: false,
    upgrade: false,
    transports: ['websocket'],
    debug: false
}
